<template>
  <el-dialog
    v-if="dialogVisible"
    class="subscribe-oracle-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="40vh"
  >
    <el-form
      ref="formData"
      :model="formData"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="服务地址" prop="Addr">
        <el-input v-model="formData.Addr" placeholder="ip:port"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleSubmit()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'SubscribeDialog',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      formData: {
        Addr: '' //预言机名称
      },
      title: '订阅预言机',
      position: 'right',
      editRule: {
        Addr: [{ required: true, message: '请输入服务地址', trigger: 'blur' }]
        // port: [
        //   { required: true, message: '请输入服务端口', trigger: 'blur' },
        //   { pattern: /^(102[5-9]|10[3-9]\d|[2-9]\d{3,})$/, message: '请正确输入端口', trigger: 'blur' }
        // ],
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    //订阅预言机
    handleSubmit() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          this.disabled = true
          let params = {}
          params = this.formData
          //获取form数据
          this.$apis.oracleManagement
            .subscribeOracle(params)
            .then(res => {
              if (res) {
                this.$message.success('订阅预言机成功')
                this.$emit('update:list')
                this.disabled = false
              } else {
                this.disabled = false
                this.$message.error(errCode[err.response['data']['errors'][0]['code']])
              }
              this.handleCancel()
            })
            .catch(err => {
              this.disabled = false
              this.$message.error(errCode[err.response['data']['errors'][0]['code']])
            })
        } else {
          this.disabled = false
          this.$message.warning('请完善信息')
          return
        }
      })
    },

    handleOpen(data) {
      this.formData = {
        Addr: '', //预言机名称
        OracleID: data
      }
      this.dialogVisible = true
    },

    handleCancel() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.subscribe-oracle-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
